import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { VehiculosService } from '../../services/vehiculos.service';
import { PaginadorService } from '../../paginador/paginador.service';
import pageSettings from '../../config/page-settings';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Vehiculo } from '../../models/vehiculos.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VehiculosNewComponent } from './vehiculos-new.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-vehiculos',
  templateUrl: './vehiculos.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: []
})
export class VehiculosComponent implements OnInit {

  pageSettings = pageSettings;
  data_list = [];
  items = [1 , 2, 3, 4];
  buscando: boolean = false;
  frmBuscar: FormGroup;

  constructor(
    private _serviceVehiculos: VehiculosService,
    private _servicePaginador: PaginadorService,
    private fb: FormBuilder,
    private modalService: NgbModal
    ) { 
      this.pageSettings.pageWithoutSidebar = false;
      this.pageSettings.pageTopMenu = false;
    }

  ngOnInit() {
    this.buscando = false;
    this.frmBuscar = this.fb.group({
      _txtBuscar: ['']
    });
   this.getLista('1', '10');
  }

  getLista(pagina: string, limit: string) {
    this._serviceVehiculos.get_listar_clientes_vehiculos(pagina, limit).subscribe((resp: any) => {
      this.data_list = resp.data;
      this._servicePaginador.page$.emit(pagina);
      this._servicePaginador.registros$.emit(resp.registros);
    });
  }

  getBuscar(pagina: string, limit: string, buscar: string) {
    console.log("Buscar...", buscar);
    this.buscando = true;
    this._serviceVehiculos.get_buscar(pagina, limit, buscar).subscribe((resp: any) => {
      this.data_list = resp.data;
      this._servicePaginador.page$.emit(pagina);
      this._servicePaginador.registros$.emit(resp.registros);
    });
  }

  receiveMessage($event: any) {
    if (this.frmBuscar.controls._txtBuscar.value === '') {
      this.buscando = false;
    }

    if (!this.buscando)
    {
      this.getLista($event.pagina, $event.recxpag);
    } 

    if (this.buscando)
    {
      const value = this.frmBuscar.controls._txtBuscar.value;
      this.getBuscar($event.pagina, $event.recxpag, value);
    } 

  }

  new (model: Vehiculo) {
    const ref = this.modalService.open(VehiculosNewComponent, { centered: true, size: 'lg', backdrop: 'static'});
    ref.componentInstance._model = model;
    ref.componentInstance.isEdit = false;
    ref.result.then((data) => {
      if (data.valido) {
        this._serviceVehiculos.create(data.frm).subscribe((resp: any) => {
          if (resp.data === 'ok') {
            this.getLista('1', '10');
          }
          else {
            Swal.fire("Atención", resp.data, "error");
          }

        });
      }
      else {
        Swal.fire("Atención", "Los datos no son válidos", "error");
      }
    }, (cancel) => {

      });

  }

  Buscar() {
    const value = this.frmBuscar.controls._txtBuscar.value;
    if (value.length > 0) {
      this.buscando = true;
      this.getBuscar('1', '10', value);
    }
    else {
      this.getLista('1', '10');
    }
  }

  edit (model: Vehiculo) {
    const ref = this.modalService.open(VehiculosNewComponent, { centered: true, size: 'lg', backdrop: 'static'});
    ref.componentInstance._model = model;
    ref.componentInstance.isEdit = true;
    ref.componentInstance._cliente = model.cliente_nombre;
    ref.result.then((data) => {
      if (data.valido) {
        this._serviceVehiculos.update(model.vehiculo_id.toString(), data.frm).subscribe((resp: any) => {
          if (resp.data === 'ok') {
            this.getLista('1', '10');
          }
          else {
            Swal.fire("Atención", resp.msg, "error");
          }

        });
      }
      else {
        Swal.fire("Atención", "Los datos no son válidos", "error");
      }
    }, (cancel) => {

      });


  }

  delete(model: Vehiculo) {
     Swal.fire({
      title: '<span style="font-size: 20px;"> Seguro de eliminar el registro?</span>',
      html: '<p><b>Vehiculo No.:</b> ' + model.numero + '</p>',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this._serviceVehiculos.getdelete(model.vehiculo_id.toString()).subscribe((resp: any) => {
          if (resp.data === 'ok') {
            this.getLista('1', '10');
            Swal.fire('Información', 'El registro ha sido eliminado...', 'success');
          }
          else {
            Swal.fire('Atención', resp.msg, 'warning');
          }
        });
      } 
    });
  }

}
